module.exports = __webpack_public_path__ + "static/media/emotion.d9850a07.mp3";